import * as React from 'react';
import { Container, Flex, Heading, Text } from '../../components';
import { SanityFile } from '../../types/sanity-types';
import { FormattedMessage } from 'react-intl';
import { ArticleText } from './ArticleText';
import { NavLink } from './NavLink';

export function ArticleLayout({
  file,
  heading,
  intro,
  content,
  appContent
}: {
  heading: React.ReactNode;
  intro: React.ReactNode;
  content: React.ReactNode;
  file?: SanityFile;
  appContent: boolean;
}) {
  const isFileObjectEmpty =
    file === undefined || file === null || Object.keys(file).length === 0;

  return (
    <Container bleed fullWidth={appContent}>
      <ArticleText appContent={appContent}>
        {!isFileObjectEmpty && (
          <Flex justifyContent="center" mt={5}>
            <NavLink textDecoration="underline" href={`${file?.file}?dl=`}>
              <FormattedMessage
                id="modules.Profile.YourData.table.state.processed"
                defaultMessage="Download file"
              />
            </NavLink>
          </Flex>
        )}
        {heading && (
          <Heading textAlign="center" mb="sm" mt="md">
            {heading}
          </Heading>
        )}
        {intro && (
          <Text lead textAlign="center" mb="md">
            {intro}
          </Text>
        )}
        {content}
      </ArticleText>
    </Container>
  );
}
